// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var MM_parser = require("./MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");

function parenCntMake(parentheses, checkParensOptimizedOpt, param) {
  var checkParensOptimized = checkParensOptimizedOpt !== undefined ? checkParensOptimizedOpt : true;
  var parenLen = parentheses.length;
  if (parenLen % 2 !== 0) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "mod(parenLen, 2)  != 0 in parenCntMake"
          },
          Error: new Error()
        };
  }
  if (parenLen === 0) {
    return {
            min: 0,
            parens: [],
            parentStack: [],
            failed: false
          };
  }
  var parens = [];
  var maxI = (parenLen / 2 | 0) - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    var openCode = Caml_array.get(parentheses, (i << 1));
    var closeCode = Caml_array.get(parentheses, (i << 1) + 1 | 0);
    parens.push({
          code: openCode,
          isOpen: true,
          opposite: closeCode
        });
    parens.push({
          code: closeCode,
          isOpen: false,
          opposite: openCode
        });
  }
  var min = parentheses.reduce((function (min, p) {
          if (min <= p) {
            return min;
          } else {
            return p;
          }
        }), Caml_array.get(parentheses, 0));
  if (checkParensOptimized && Math.abs(min) !== parenLen) {
    console.log("Warning: parentheses are not optimized (this may slow down the unification process).");
  }
  return {
          min: min,
          parens: parens,
          parentStack: [],
          failed: false
        };
}

function parenCntReset(cnt) {
  Expln_utils_common.clearArray(cnt.parentStack);
  cnt.failed = false;
}

function parenCntPut(cnt, i) {
  if (!cnt.failed && cnt.min <= i && i < 0) {
    var paren = cnt.parens.find(function (param) {
          return param.code === i;
        });
    if (paren !== undefined) {
      if (paren.isOpen) {
        cnt.parentStack.push(paren);
      } else {
        var lastParen = cnt.parentStack.pop();
        if (lastParen !== undefined && lastParen.opposite === paren.code) {
          
        } else {
          cnt.failed = true;
        }
      }
    }
    
  }
  if (cnt.failed) {
    return /* Failed */2;
  } else if (cnt.parentStack.length === 0) {
    return /* Balanced */0;
  } else {
    return /* Opened */1;
  }
}

exports.parenCntMake = parenCntMake;
exports.parenCntReset = parenCntReset;
exports.parenCntPut = parenCntPut;
/* No side effect */
